export const SET_ELEMENT_CURSOR = 'SET_ELEMENT_CURSOR';
export const CLEAR_ELEMENT_CURSOR = 'CLEAR_ELEMENT_CURSOR';
export const SELECT_ELEMENT_CURSOR_CATEGORY = 'SELECT_ELEMENT_CURSOR_CATEGORY';
export const SELECT_ELEMENT_CURSOR_SUBCATEGORY = 'SELECT_ELEMENT_CURSOR_SUBCATEGORY';

export const setElementCursor = (scribeId, elementIds, cursorId) => ({
  type: SET_ELEMENT_CURSOR,
  scribeId,
  elementIds,
  cursorId
});

export const clearElementCursor = (scribeId, elementIds) => ({
  type: CLEAR_ELEMENT_CURSOR,
  scribeId,
  elementIds
});

export const selectElementCursorCategory = (scribeId, elementIds, cursorCategory) => ({
  type: SELECT_ELEMENT_CURSOR_CATEGORY,
  scribeId,
  elementIds,
  cursorCategory
});

export const selectElementCursorSubCategory = (scribeId, elementIds, cursorSubCategory) => ({
  type: SELECT_ELEMENT_CURSOR_SUBCATEGORY,
  scribeId,
  elementIds,
  cursorSubCategory
});
